import { useQuery } from "@tanstack/react-query";
import {
  DETAILS_CACHE_TIME,
  DETAILS_STALE_TIME,
  getUserDetails,
} from "../consumer";
import {
  MESSAGE_CACHE_TIME,
  MESSAGE_STALE_TIME,
  filterVisibleMessages,
  getMessageList,
  getMessageListSeen,
  isConsumerUltraInsider,
  isPackPrizeMessage,
} from "./index";

export function useVisibleMessages({
  seen = false,
  refetchInterval,
} = {}) {
  const detailsQuery = useQuery({
    queryKey: ["user-details"],
    queryFn: getUserDetails,
    staleTime: DETAILS_STALE_TIME,
    cacheTime: DETAILS_CACHE_TIME,
    suspense: false,
  });

  const listQuery = useQuery({
    queryKey: seen ? ["message-list", "seen"] : ["message-list"],
    queryFn: seen ? getMessageListSeen : getMessageList,
    staleTime: MESSAGE_STALE_TIME,
    cacheTime: MESSAGE_CACHE_TIME,
    suspense: false,
    refetchInterval,
  });

  const ultraInsider = isConsumerUltraInsider(detailsQuery.data);
  const rawMessages = Array.isArray(listQuery.data?.messages)
    ? listQuery.data.messages
    : [];
  const messages = filterVisibleMessages(rawMessages, ultraInsider);

  return {
    listQuery,
    detailsQuery,
    rawMessages,
    messages,
    packPrizeMessage: rawMessages.find(isPackPrizeMessage),
    count: messages.length,
    ultraInsider,
    isListLoaded: Boolean(listQuery.data),
  };
}
